import { useEffect, useState } from "react"
import MTable from "../../components/mtable"
import { api } from "../../env"
import LoadingButton from "../../components/LoadingButton"
import { useNavigate, useParams } from "react-router-dom"
import { clearStorage, getStorage, setStorage, STORAGE } from "../../utils/storage"
import { routeEnrollment } from "../../utils/enrollment"

export default function ParticipantInvites() {
    
    const navigate = useNavigate()
    const { invitationCode } = useParams()
    const [selectedInvite, setSelectedInvite] = useState(undefined)

    useEffect(() => {
        if (invitationCode) {
            setStorage(STORAGE.PARTICIPANT_INVITE_CODE, invitationCode)
            setStorage(STORAGE.PARTICIPANT_INVITE_MADE_ACCOUNT, false)
        }
        let code = invitationCode ? invitationCode : getStorage(STORAGE.PARTICIPANT_INVITE_CODE)
        if (code) api.get('invitations/public/overview', {params: {invitationCode: code}})
            .then(res => {
                let details = res.data
                setSelectedInvite({
                    isPublic: true,
                    invitationCode: code,
                    name: details.programName,
                    role: details.type,
                    isAccepting: true
                })
            })
        else checkForEnrollments()
    }, [invitationCode])

    const handleInviteResponse = (invitation, isAccepting) => {
        setSelectedInvite({
            isPublic: false,
            invitationId: invitation.invitationId,
            name: invitation.programName,
            role: invitation.type,
            isAccepting
        })
    }

    const clearInvitation = () => {
        clearStorage([STORAGE.PARTICIPANT_INVITE_CODE, STORAGE.PARTICIPANT_INVITE_MADE_ACCOUNT])
        setSelectedInvite(undefined)
    }

    const handleAccepted = () => {
        clearInvitation()
        checkForEnrollments()
    }

    const checkForEnrollments = () => {
        api.get('accounts/me/enrollments', { params: { page: 1, limit: 10}})
            .then(res => {
                console.log(res.data)
                let enrollment = res.data.data[0]
                navigate(routeEnrollment(enrollment))
            })
            .catch(_ => {})
    }

    return(<div className="standard-padding page-l-centered h-100 flex columns justify-center">
        {!selectedInvite && <PendingInvites handleResponse={handleInviteResponse}/>}
        {selectedInvite && <RespondToInvite invite={selectedInvite} onBack={clearInvitation} onAccept={handleAccepted}/>}
    </div>)
}

function PendingInvites({handleResponse}) {

    const mapper = {columns: [
        {
            label: "Name",
            value: (item) => item.programName
        },
        {
            label: "Role",
            value: (item) => item.type,
            width: "2fr"
        },
        {
            label: "Actions",
            actions: [
                {
                    label: "Reject",
                    style: (_) => "outline",
                    onClick: (item) => handleResponse(item, false)
                },
                {
                    label: "Accept",
                    style: (_) => "solid-accent",
                    onClick: (item) => handleResponse(item, true)
                }
            ],
            width: "200px"
        }
    ]}

    return(<>
        <p className="section-title text-center v-spacer-xxs">Pending Invites</p>
        <p className="card-body neutral text-center v-spacer-l">Please wait until you get invited to a program</p>
        <MTable path={'accounts/me/invitations'} mapper={mapper} />
    </>)
}

function RespondToInvite({invite, onBack, onAccept}) {

    const [isLoading, setIsLoading] = useState(false)

    const reject = () => {
        api.put(`invitations/personal/${invite.invitationId}/reject`)
            .then(res => {
                setIsLoading(false)
                onBack()
            })
            .catch(_ => onBack())
    }

    const accept = () => {
        let url = invite.isPublic ? 'invitations/public/accept' : `invitations/personal/${invite.invitationId}/accept`
        let body = invite.isPublic ? { invitationCode: invite.invitationCode } : undefined
        api.put(url, body)
            .then(res => {
                setIsLoading(false)
                onAccept()
            })
            .catch(_ => onBack())
    }

    const handleOnClick = () => {
        if (invite.isAccepting) accept()
        else if (!invite.isPublic) reject()
        else onBack()
    }

    return(<>
        <p className="section-title text-center v-spacer-m">Respond to Invite</p>
        <p className="card-title light text-center v-spacer-l">
            Are you sure you want to
            <span className="bold accent"> {invite.isAccepting ? 'Accept' : 'Reject'} </span> 
            invite to
            <span className="bold"> {invite.name} </span> 
            program?
        </p>
        <div className="flex center justify-center gap-xs">
            <button className="outline large" onClick={onBack}>Cancel</button>
            <LoadingButton className={"solid-accent large"} label={invite.isAccepting ? 'Accept' : 'Reject'} isLoading={isLoading} onClick={handleOnClick}/>
        </div>
    </>)
}